import {
  appConfigProviderKey,
  defaultFormatter,
  formatNumber,
  formatterProviderKey,
  linksProviderKey,
} from '@metapic-apps/shared'
import type { App } from 'vue'

import store from '@/legacy/store'
import { formatMoneyMinorForAdvertiser } from '@/lib/formatters/money.formatter'
import { config } from '@/lib/helpers/config.helpers'

const hasCreatorPageAccess = () =>
  !store.getters['shop/hideUsers'] &&
  !store.getters['shop/hideSales'] &&
  !store.getters['shop/hideCosts']

export const installProviders = (app: App) => {
  app.provide(appConfigProviderKey, {
    mediaBaseUrl: config.mediaBaseUrl,
  })

  app.provide(formatterProviderKey, {
    ...defaultFormatter,
    formatMoney: formatMoneyMinorForAdvertiser,
    formatNumber: formatNumber,
  })

  app.provide(linksProviderKey, {
    getCreatorLink: (creatorId) => {
      if (!hasCreatorPageAccess()) {
        return null
      }
      return `/creators/${creatorId}`
    },
    getAdvertiserLink: () => null,
    getCampaignLink: (campaignId) => `/campaign-users/${campaignId}`,
  })
}
